//This file is generated from c# do not modify, any changes will be overridden when re-generated.
import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
export class RelateConceptVersionModel extends ModelBase {
    static readonly $typeName = 'RelateConceptVersionModel';
    public code: string;
    public valueSetCode: string;
    public codeSystemVersionKey: string;
    
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/RelateConceptVersionModel.ts